import { useMutation } from 'urql';
import { CreateDirectoryInput, Mutation } from 'api';
import { CREATE_DIRECTORY_MUTATION } from 'api/graphql/mutations/directory';

type MutationType = Pick<Mutation, 'createDirectory'>;

export const useCreateFolder = () => {
    const [state, executeMutation] = useMutation<MutationType>(CREATE_DIRECTORY_MUTATION);

    const createFolder = async (input: CreateDirectoryInput) => {
        const { error, data } = await executeMutation({ input });

        if (error) {
            return { error: error.graphQLErrors[0].extensions?.code };
        }

        return { data };
    };

    return {
        state,
        createFolder,
    };
};
